import React, { useState } from 'react';

export default function ContactForm({ bgImage, title = 'Compila\nil form', productName }) {
  const [form, setForm] = useState({ nome: '', cognome: '', email: '', telefono: '', messaggio: '' });
  const [sent, setSent] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form inviato:', form);
    setSent(true);
    setTimeout(() => setSent(false), 5000);
    setForm({ nome: '', cognome: '', email: '', telefono: '', messaggio: '' });
  };

  return (
    <>
      <style>{`
        .contact-section { background: #000; position: relative; overflow: hidden; min-height: 550px; display: flex; align-items: center; }
        .contact-bg { position: absolute; right: 0; top: 0; width: 55%; height: 100%; object-fit: cover; object-position: center center; }
        .contact-cover { position: absolute; inset: 0; background: #000; z-index: 1; clip-path: polygon(0 0, calc(53% + 8px) 0, calc(45% + 8px) 100%, 0 100%); }
        .contact-line { position: absolute; inset: 0; background: #d71921; z-index: 2; pointer-events: none; clip-path: polygon(calc(53% - 8px) 0%, calc(53% + 8px) 0%, calc(45% + 8px) 100%, calc(45% - 8px) 100%); }
        .contact-content { position: relative; z-index: 3; padding: 64px 30px 64px 110px; width: 40%; box-sizing: border-box; }
        .contact-title { font-family: 'Alumni Sans', sans-serif; font-weight: 500; font-size: 45px; line-height: 40px; color: #fff; margin-bottom: 29px; white-space: pre-line; }
        .contact-grid2 { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 10px; }
        .contact-field { display: flex; flex-direction: column; gap: 5px; }
        .contact-label { font-family: 'Alumni Sans', sans-serif; font-size: 14px; color: #fff; }
        .contact-input { background: #fff; border: none; color: #000; font-family: 'Roboto', sans-serif; font-size: 13px; padding: 8px 10px; outline: none; width: 100%; box-sizing: border-box; }
        .contact-input::placeholder { color: #aaa; }
        .contact-textarea { background: #fff; border: none; color: #000; font-family: 'Roboto', sans-serif; font-size: 13px; padding: 10px; outline: none; width: 100%; min-height: 88px; resize: vertical; margin-bottom: 10px; box-sizing: border-box; }
        .contact-textarea::placeholder { color: #aaa; }
        .contact-btn { background: #d71921; color: #fff; font-family: 'Alumni Sans', sans-serif; font-weight: 600; font-size: 18px; padding: 11px; width: 100%; cursor: pointer; border: none; transition: opacity 0.2s; }
        .contact-btn:hover { opacity: 0.85; }
        .contact-success { background: rgba(215,25,33,0.15); border: 1px solid #d71921; color: #fff; padding: 10px; font-family: 'Roboto', sans-serif; font-size: 13px; margin-top: 10px; }

        @media (max-width: 1300px) {
          .contact-content { padding: 56px 30px 56px 64px; width: 50%; }
          .contact-cover { clip-path: polygon(0 0, calc(60% + 8px) 0, calc(54% + 8px) 100%, 0 100%); }
          .contact-line { clip-path: polygon(calc(60% - 8px) 0%, calc(60% + 8px) 0%, calc(54% + 8px) 100%, calc(54% - 8px) 100%); }
        }
        @media (max-width: 1100px) {
          .contact-section { min-height: 480px; }
          .contact-bg { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; object-position: center center; opacity: 0.2; }
          .contact-cover { clip-path: none; background: rgba(0,0,0,0.5); }
          .contact-line { display: none; }
          .contact-content { width: 100%; max-width: 100%; padding: 50px 60px; display: grid; grid-template-columns: 1fr 1fr; gap: 48px; align-items: center; }
          .contact-title { margin-bottom: 0; }
        }
        @media (max-width: 900px) {
          .contact-section { min-height: auto; }
          .contact-bg { display: none; }
          .contact-cover { display: none; }
          .contact-content { width: 100%; padding: 50px 20px; display: block; }
          .contact-title { font-size: 36px; line-height: 32px; margin-bottom: 22px; }
        }
        @media (max-width: 500px) {
          .contact-grid2 { grid-template-columns: 1fr; }
          .contact-title { font-size: 30px; line-height: 28px; }
        }
      `}</style>

      <section className="contact-section" id="contatti">
        {bgImage && <img src={bgImage} alt="" className="contact-bg" />}
        {bgImage && <div className="contact-cover" />}
        {bgImage && <div className="contact-line" />}
        <div className="contact-content">
          <h2 className="contact-title">
            {productName ? 'Richiedi informazioni\nsul prodotto' : title}
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="contact-grid2">
              <div className="contact-field">
                <label className="contact-label">Nome:</label>
                <input className="contact-input" name="nome" value={form.nome} onChange={handleChange} placeholder="Falcon" required />
              </div>
              <div className="contact-field">
                <label className="contact-label">Cognome:</label>
                <input className="contact-input" name="cognome" value={form.cognome} onChange={handleChange} placeholder="Fishing" required />
              </div>
              <div className="contact-field">
                <label className="contact-label">Email:</label>
                <input className="contact-input" type="email" name="email" value={form.email} onChange={handleChange} placeholder="falcon@gmail.com" required />
              </div>
              <div className="contact-field">
                <label className="contact-label">Telefono:</label>
                <input className="contact-input" name="telefono" value={form.telefono} onChange={handleChange} placeholder="+39 340 000 00 00" />
              </div>
            </div>
            <div className="contact-field" style={{marginBottom: 12}}>
              <label className="contact-label">Messaggio:</label>
              <textarea
                className="contact-textarea"
                name="messaggio"
                value={form.messaggio}
                onChange={handleChange}
                placeholder={productName ? `Vorrei informazioni sul prodotto: ${productName}` : 'Scrivi il tuo messaggio...'}
                required
              />
            </div>
            <button type="submit" className="contact-btn">Invia messaggio</button>
            {sent && <div className="contact-success">✓ Messaggio inviato con successo!</div>}
          </form>
        </div>
      </section>
    </>
  );
}
